import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import {
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MAT_DIALOG_DATA,
    MatDialogRef,
} from "@angular/material/dialog";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { QuestScheduleViewModel } from "@playcharge/common/models/backend/quests/backoffice/quest-schedule-view-model";

@Component({
    selector: "app-quest-schedule-edit-dialog",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatFormField,
        MatLabel,
        MatInput,
        MatButton,
    ],
    templateUrl: "./quest-schedule-edit-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestScheduleEditDialogComponent implements OnInit {
    private _matDialogRef: MatDialogRef<QuestScheduleEditDialogComponent, { name: string }> =
        inject(MatDialogRef<QuestScheduleEditDialogComponent, { name: string }>);
    private _matDialogData: Nullable<QuestScheduleViewModel> = inject(MAT_DIALOG_DATA);

    public form: FormGroup<{
        name: FormControl<string>;
    }> = new FormGroup({
        name: new FormControl<string>("", { nonNullable: true, validators: [Validators.required] }),
    });

    public ngOnInit(): void {
        this.form.patchValue({
            name: this._matDialogData?.name ?? "",
        });
    }

    public close(): void {
        this._matDialogRef.close(this.form.getRawValue());
    }
}
